import React from 'react'

import I18n from 'APP/I18n'

import { InnerBox, LoadingText, Overlay, Spinner } from './style'

interface AttachmentLoadingOverlayProps {
  text?: string | null
}

export const AttachmentLoadingOverlay: React.FC<AttachmentLoadingOverlayProps> = ({ text }) => (
  <Overlay>
    <InnerBox>
      <LoadingText>{text || I18n.t('ConversationScreen.loading')}</LoadingText>
      <Spinner />
    </InnerBox>
  </Overlay>
)
